// extracted by mini-css-extract-plugin
module.exports = {"orLine":"styles_orLine__38Lz9","orText":"styles_orText__2COTt","fbDisclaimer":"styles_fbDisclaimer__3BL94"};